import Header49_wave_animated from './Header49_wave_animated'
export default Header49_wave_animated
